import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { AuthStore } from './auth.store';

/** Espace admin : session requise. Le rôle ADMIN est vérifié par le serveur. */
export const authGuard: CanMatchFn = () => {
  const auth = inject(AuthStore);
  return auth.isLoggedIn() || inject(Router).createUrlTree(['/connexion']);
};

/** Page de connexion : inutile si déjà connecté. */
export const guestGuard: CanMatchFn = () => {
  const auth = inject(AuthStore);
  return !auth.isLoggedIn() || inject(Router).createUrlTree(['/']);
};
